import styled from '@emotion/styled';
import Magnifier from '@ep/images/magnifier.svg';
import React, { useState } from 'react';
import SearchBarModal from './SearchBarModal';

export interface SearchBarProps {
  hidden: boolean;
}

const StyledMagnifier = styled(Magnifier)`
  margin-top: 1rem;
  margin-left: 1rem;
  cursor: pointer;
`;

function SearchBar() {
  function handleOpen() {
    const searchBar = document.getElementById('search-bar');

    if (searchBar) {
      // search bar already open
    } else {
      setIsOpen(true);
    }
  }

  function handleClose() {
    setIsOpen(false);
  }

  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <StyledMagnifier onClick={handleOpen} />
      <SearchBarModal open={isOpen} onClose={handleClose} />
    </>
  );
}

export default SearchBar;
